'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function (node) {
	return {
		type: 'NOTICE',
		name: 'Notice',
		allowedSections: ['footer', 'header', 'main', 'article'],
		disallowedChildren: [],
		category: 'Layout',
		icon: 'fal fa-exclamation-circle',
		props: [{
			name: 'show',
			inputType: 'checkbox',
			label: 'Show notice',
			default: true
		}, {
			name: 'noticeStateStorageMethod',
			inputType: 'select',
			label: 'How long should Notice stay closed',
			default: 'session',
			values: [{
				label: 'Until new session',
				value: 'session'
			}, {
				label: 'Cookie defined (Set length)',
				value: 'cookie'
			}]
		}, node && node.props.noticeStateStorageMethod === 'cookie' && {
			name: 'cookieMaxAge',
			inputType: 'number',
			label: 'How long should the cookie live (in days)',
			default: '90'
		}].filter(Boolean)
	};
};